/**
 * Composite `{id}-{nanoId}` lead identifier — the form the new lead page
 * routes on and the one external systems (e.g. Task Manager linked entities)
 * expect. The nanoId-only fallback covers backend responses that predate the
 * journey id being returned.
 */
export const compositeLeadNanoId = (
  id: number | string | null | undefined,
  nanoId: string,
): string =>
  id != null && String(id).trim() !== "" ? `${id}-${nanoId}` : nanoId;

/**
 * Open a lead's page in a separate browser tab.
 *
 * Uses the composite `{id}-{nanoId}` new-lead-page route, identical to the
 * journey link in the All Calls table. Opening in a new tab keeps the
 * zoom-calls list (and any open call drawer) intact.
 */
export const openLeadInNewTab = (
  id: number | string | null | undefined,
  nanoId: string,
): void => {
  window.open(
    `/leads-new/${compositeLeadNanoId(id, nanoId)}`,
    "_blank",
    "noopener,noreferrer",
  );
};
